(() => {
  const updateCartLinkAccessibleNames = (count) => {
    if (!Number.isInteger(count) || count < 0) return;

    document.querySelectorAll('[data-cart-count-accessible-name]').forEach((link) => {
      const itemLabel = count === 1 ? link.dataset.cartItemLabel : link.dataset.cartItemsLabel;
      link.setAttribute('aria-label', `${link.dataset.cartTitle}, ${count} ${itemLabel}`);
    });
  };

  document.documentElement.addEventListener('wetheme-cart-update', (event) => {
    updateCartLinkAccessibleNames(event.detail?.cart?.item_count);
  });
})();
